export const VERIFY_SUFFICIENT_FUNDS_REQUEST = 'VERIFY_SUFFICIENT_FUNDS_REQUEST';
export const VERIFY_SUFFICIENT_FUNDS_SUCCESS = 'VERIFY_SUFFICIENT_FUNDS_SUCCESS';
export const VERIFY_SUFFICIENT_FUNDS_FAILURE = 'VERIFY_SUFFICIENT_FUNDS_FAILURE';

export const FETCH_PAYMENT_METHODS_REQUEST = 'FETCH_PAYMENT_METHODS_REQUEST';
export const FETCH_PAYMENT_METHODS_SUCCESS = 'FETCH_PAYMENT_METHODS_SUCCESS';
export const FETCH_PAYMENT_METHODS_FAILURE = 'FETCH_PAYMENT_METHODS_FAILURE';

export const FETCH_CONNECTIONS_BILLING_PREVIEW_REQUEST = 'FETCH_CONNECTIONS_BILLING_PREVIEW_REQUEST';
export const FETCH_CONNECTIONS_BILLING_PREVIEW_SUCCESS = 'FETCH_CONNECTIONS_BILLING_PREVIEW_SUCCESS';
export const FETCH_CONNECTIONS_BILLING_PREVIEW_FAILURE = 'FETCH_CONNECTIONS_BILLING_PREVIEW_FAILURE';

export const SET_DEFAULT_PAYMENT_METHOD_REQUEST = 'SET_DEFAULT_PAYMENT_METHOD_REQUEST';
export const SET_DEFAULT_PAYMENT_METHOD_SUCCESS = 'SET_DEFAULT_PAYMENT_METHOD_SUCCESS';
export const SET_DEFAULT_PAYMENT_METHOD_FAILURE = 'SET_DEFAULT_PAYMENT_METHOD_FAILURE';

export const GET_PAYMENT_METHODS_DETAILS_REQUEST = 'GET_PAYMENT_METHODS_DETAILS_REQUEST';
export const GET_PAYMENT_METHODS_DETAILS_SUCCESS = 'GET_PAYMENT_METHODS_DETAILS_SUCCESS';
export const GET_PAYMENT_METHODS_DETAILS_FAILURE = 'GET_PAYMENT_METHODS_DETAILS_FAILURE';

export const RESET_NEW_PAYMENT_METHOD = 'RESET_NEW_PAYMENT_METHOD';
export const RESET_CURRENT_SELECTED = 'RESET_CURRENT_SELECTED';
export const SET_CURRENT_SELECTED = 'SET_CURRENT_SELECTED';
